import { render, staticRenderFns } from "./SimpleFileList.vue?vue&type=template&id=647ce1dc&scoped=true"
import script from "./SimpleFileList.vue?vue&type=script&lang=ts"
export * from "./SimpleFileList.vue?vue&type=script&lang=ts"
import style0 from "./SimpleFileList.vue?vue&type=style&index=0&id=647ce1dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647ce1dc",
  null
  
)

export default component.exports